"use strict";
"use client";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SciChartSurfaceContext = void 0;
const react_1 = require("react");
/**
 * React Context provided within {@link SciChartReact}
 * Stores the chart initialization result.
 */
exports.SciChartSurfaceContext = (0, react_1.createContext)(null);
//# sourceMappingURL=SciChartSurfaceContext.js.map